import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router-dom';
import { history } from './history';
import App from './components/App';
import Config from './config/Config';
import { PersistGate } from 'redux-persist/integration/react';
import { Provider } from 'react-redux';
import { store, persistor } from './getStore.js';
import * as serviceWorker from './serviceWorker.js';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import AudioRecorder from 'audio-recorder-polyfill';
import { isIos } from './utils/commonFunctions';

if (isIos()) {
	window.MediaRecorder = AudioRecorder;
}

console.log('LT', Config.LTAPIURL);
console.log("proctor testing");
ReactDOM.render(
	<Provider store={store}>
		<Router history={history}>
			<PersistGate persistor={persistor}>
				<App />
			</PersistGate>
		</Router>
	</Provider>,
	document.getElementById('myDiv'),
);

serviceWorker.unregister();
